export class UnauthorizedException {}

export class BadRequestException {
  constructor(public message: any) {}
}

export class NotFoundException {}
